import React from 'react';
import { AddOnCardContainer } from './style';
import { SwitchOffIconNew, SwitchOnIconNew, GreenCheckIconNew, ContPlus, ContMinus } from 'assets/icons';

export type AddOnCardProps = {
  title: string;
  attributes: string[];
  attributesText?: string;
  checked?: boolean;
  setChecked?: () => void;
  value?: number;
  setValue?: (newValue: number) => void;
  valueText?: string;
  numberOfNights?: number;
  setNumberOfNights?: (newValue: number) => void;
  numberOfNightsText?: string;
  price: number;
  isOneTimePriced: boolean;
  explanation?: React.ReactNode;
  showItemPrice?:  boolean;
  explanationPositionLeft?: boolean;
  maxNumberOfNights?: number;
};



const AddOnCard: React.FC<AddOnCardProps> = ({
  title,
  attributes,
  checked,
  setChecked,
  value,
  setValue,
  price,
  isOneTimePriced,
  explanation,
  valueText,
  numberOfNightsText,
  numberOfNights,
  setNumberOfNights,
  attributesText,
  showItemPrice,
  explanationPositionLeft,
  maxNumberOfNights,
}) => {

  const reachedMaxNights =
  typeof numberOfNights === "number" &&
  typeof maxNumberOfNights === "number" &&
  numberOfNights >= maxNumberOfNights;

  const reachedMinNights =
  typeof numberOfNights === "number" && numberOfNights <= 1;

  const reachedMinQty =
  typeof value === "number" && value <= 0;

  const handleIncrement = (e: React.MouseEvent) => {
    e.stopPropagation();
    if (setValue && typeof value === "number") {
      setValue(value + 1);
    }
  };

  const handleDecrement = (e: React.MouseEvent) => {
    e.stopPropagation();
    if (setValue && typeof value === "number" && value > 0) {
      setValue(value - 1);
    }
  };

  const handleNumberOfNightsIncrement = (e: React.MouseEvent) => {
    e.stopPropagation();
  
    if (!setNumberOfNights || typeof numberOfNights !== "number") return;
  
    const max = typeof maxNumberOfNights === "number" ? maxNumberOfNights : Number.POSITIVE_INFINITY;
  
    if (numberOfNights < max) {
      setNumberOfNights(numberOfNights + 1);
    }
  };

  const handleNumberOfNightsDecrement = (e: React.MouseEvent) => {
    e.stopPropagation();
  
    if (!setNumberOfNights || typeof numberOfNights !== "number") return;
  
    if (numberOfNights > 1) {
      setNumberOfNights(numberOfNights - 1);
    }
  };

  return (
    <AddOnCardContainer
    // onClick={setChecked}
    >
      <div className="optionCardTitle">
        {title}
      </div>
      <div className="optionCardAttributes">
        {
          attributes.map((attribute, index) => {
            return (
              <div key={index} className="roomAttribute">
                <GreenCheckIconNew />
                <div className="roomAttributeText">{attribute}</div>
              </div>
            )
          })
        }
      </div>
      {attributesText && (
        <div className="attributesText">{attributesText}</div>
      )}
      <div className="optionCardPrice">
        <div className={`${explanationPositionLeft ? "counterPrice" : "counterPriceRight"}`}>
          {typeof value === "number" && setValue ? (
            <>
              <div className="counter">
                <ContMinus
                  onClick={reachedMinQty ? undefined : handleDecrement}
                  className={`counterBtn counterRt ${reachedMinQty ? "disabled" : ""}`}
                />
                <span className="counterValue">{value}</span>
                <span className="counterText">{valueText ?? ""}</span>
                <ContPlus onClick={handleIncrement} className="counterBtn counterLft" />
              </div>

              {typeof numberOfNights === "number" && setNumberOfNights ? (
                <div className="counter">
                  <div className="counterFor">For</div>
                  <ContMinus
                    onClick={reachedMinNights ? undefined : handleNumberOfNightsDecrement}
                    className={`counterBtn counterRt ${reachedMinNights ? "disabled" : ""}`}
                  />
                  <span className="counterValue">{numberOfNights}</span>
                  <span className="counterText">{numberOfNightsText ?? ""}</span>
                  <ContPlus
                    onClick={reachedMaxNights ? undefined : handleNumberOfNightsIncrement}
                    className={`counterBtn counterLft ${reachedMaxNights ? "disabled" : ""}`}
                  />
                </div>
              ) : null}
            </>
          ) : (
            <div className={`switch ${checked ? "active" : ""}`} onClick={setChecked}>
              <div className={`switchSlider ${checked ? "active" : ""}`}>
                {checked ? <SwitchOnIconNew /> : <SwitchOffIconNew />}
              </div>
            </div>
          )}
          {showItemPrice && (
            <div className="price">
              {`+ $${price.toFixed(2)}`}
            </div>
          )}
        </div>
        <div className={`explanation ${explanationPositionLeft ? "" : "explanationRight"}`}>
          {explanation ?? `per room, ${isOneTimePriced ? "" : "per night, "} not including taxes.`}
        </div>
      </div>
    </AddOnCardContainer>
  )
}
export default AddOnCard;
